/* SF76: selected merchandising interactions only; existing Clarity owns delivery. */
(() => {
  if (window.sf76IntentEventsBound) return;
  window.sf76IntentEventsBound = true;
  const events = Object.freeze({
    coffee_natural: 'sf76_coffee_natural',
    coffee_aras: 'sf76_coffee_aras',
    home_shop: 'sf76_home_shop',
    home_discovery: 'sf76_home_discovery',
    home_gifts: 'sf76_home_gifts',
    home_category: 'sf76_home_category',
    category_filter: 'sf76_category_filter',
    home_shipping: 'sf76_home_shipping',
    home_help: 'sf76_home_help',
    guide_product: 'sf76_guide_product',
    pdp_collection_return: 'sf76_pdp_collection_return',
    visit_shop: 'sf76_visit_shop',
    visit_gifts: 'sf76_visit_gifts',
    shipping_returns: 'sf76_shipping_returns',
    recently_viewed: 'sf76_recently_viewed',
    sold_out_product: 'sf76_sold_out_product',
    sold_out_browse: 'sf76_sold_out_browse',
    sold_out_variant: 'sf76_sold_out_variant',
    sold_out_restock_option: 'sf76_sold_out_restock_option',
  });
  // Load permission reads only. Never register consent on a visitor's behalf.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch (_) { /* Measurement must not interrupt shopping. */ }
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-sf76-action], .product__info-container a[href="/pages/shipping-and-returns"], recently-viewed-products a[href*="/products/"]');
    const action = link?.dataset.sf76Action || (link?.closest('recently-viewed-products') ? 'recently_viewed' : (link?.matches('.product__info-container a[href="/pages/shipping-and-returns"]') ? 'shipping_returns' : null));
    if (!Object.hasOwn(events, action)) return;
    const name = events[action];
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', name);
    } catch (_) { /* Missing or blocked analytics never prevents navigation. */ }
  }, { passive: true });
})();
